module.exports = __webpack_public_path__ + "star_title.374ccaff.png";